import { useEffect } from 'react'
import { trackExperimentViewed } from '@mc/track-event'
import { REDIS_CACHE_FLAG } from '@mc/next-cache'

export const GlobalEventTracking = () => {
  useEffect(() => {
    // pen-3904_v1: track performance of Redis cache
    trackExperimentViewed(REDIS_CACHE_FLAG)
  }, [])

  return null
}
